import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TilesItemConverter extends CmsConverterService<TilesItemData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_image_title_text?.value
    const altText = formData?.st_image_alternative_text?.value
    const lazyLoad = formData?.st_image_lazy_loading?.value
    return {
      headline: formData?.st_headline ?? defaultTextInput,
      text: formData?.st_text ?? defaultTextInput,
      pointOfPicture: formData?.st_image_point_of_picture?.value?.identifier ?? '',
      image: CmsConverterService.mapImage(formData.st_image_reference, lazyLoad, altText, title),
    } as TilesItemData
  }
}

export const TILES_ITEM_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TilesItemData>>('TilesItemConverter')

export interface TilesItemData extends ConvertedComponentData {
  headline: TextInput;
  text: TextInput;
  pointOfPicture: string;
  image: Image;
}
